module.exports = __webpack_public_path__ + "media/images/footer/europe-ee8045d8cb51e7c175b6f5160fe8a4f6.png";